var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 18.3505L10.5766 20.7505C10.9766 21.1505 11.8766 21.3505 12.4766 21.3505H16.2766C17.4766 21.3505 18.7766 20.4505 19.0766 19.2505L21.4766 11.9505C21.9766 10.5505 21.0766 9.35046 19.5766 9.35046H15.5766C14.9766 9.35046 14.4766 8.85046 14.5766 8.15046L15.0766 4.95046C15.2766 4.05046 14.6766 3.05046 13.7766 2.75046C12.9766 2.45046 11.9766 2.85046 11.5766 3.45046L7.47656 9.55046",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38281 18.3504V8.55039C2.38281 7.15039 2.98281 6.65039 4.38281 6.65039H5.38281C6.78281 6.65039 7.38281 7.15039 7.38281 8.55039V18.3504C7.38281 19.7504 6.78281 20.2504 5.38281 20.2504H4.38281C2.98281 20.2504 2.38281 19.7504 2.38281 18.3504Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLike;